import PropTypes from 'prop-types';
import gettext from '@eb/gettext';
import lazyGettext from 'js-utils/lazy-gettext';
import noop from 'lodash/noop';

// NB: EB-1137596 - Changed to browse online events due to COVID19 impact
// TODO: EB-138002 - Add logic to toggle button target based on collection
export const BROWSE_EVENTS_PATH = '/d/online/all-events/';

/* Shape pulled from the formatted shape returned by the
likedEvents selector */
export const EVENT_SHAPE_PROPTYPE = PropTypes.shape({
    id: PropTypes.string,
    minPrice: PropTypes.shape({
        minPriceValue: PropTypes.number,
        currencyFormat: PropTypes.string,
        currency: PropTypes.string,
    }),
    url: PropTypes.string,
    imageUrl: PropTypes.string,
    edgeColor: PropTypes.string,
    locationInfo: PropTypes.string,
    shareOptions: PropTypes.object,
    startDate: PropTypes.string,
    startTime: PropTypes.string,
    isFree: PropTypes.bool,
    ticketsBy: PropTypes.string,
    name: PropTypes.string,
    savedByYou: PropTypes.bool,
});

export const FEATURE_FLAGS_SHAPE_PROP_TYPE = PropTypes.shape({
    facetedSearch: PropTypes.bool,
    searchMapEnhancements: PropTypes.bool,
    crazyEggFeatureFlag: PropTypes.bool,
    enableHomepageV2Subscribe: PropTypes.bool,
    enableCollections: PropTypes.bool,
});

/* Shared component configurations */
export const EDIT_COLLECTION_MODAL_CONFIG = {
    primaryText: gettext('Update'),
    primaryType: 'fill',
    secondaryText: gettext('Cancel'),
    secondaryType: 'neutral',
    onClose: noop,
};

export const UPCOMING_FILTER = 'upcoming';

/* GA TRACKING CONSTANTS */
export const EDITORIAL_COLLECTION_PAGE_GA_CATEGORY = 'editorial-collection';
export const COLLECTION_PAGE_GA_CATEGORY = 'collection';
export const REMOVE_COLLECTION_GA_ACTION = 'RemoveFromCollection';
export const EDIT_COLLECTION_GA_ACTION = 'EditCollection';
export const ADD_IMAGE_GA_ACTION = 'AddImage';
export const SAVE_COLLECTION_GA_ACTION = 'SaveCollection';
export const SHARE_COLLECTION_GA_ACTION = 'ShareCollection';
export const COPY_SHARE_LINK_GA_ACTION = 'CopyShareLink';
export const BROWSE_EVENTS_GA_ACTION = 'BrowseEvents';
export const SWITCH_TAB_GA_ACTION = 'SwitchTab';
export const SHARE_EVENT_GA_ACTION = 'ShareEvent';
export const GDPR_ACCEPT_GA_ACTION = 'FollowCollectionGDPRAccept';
export const GDPR_REJECT_GA_ACTION = 'FollowCollectionGDPRReject';
export const FOLLOW_GA_ACTION = 'FollowCollection';
export const UNFOLLOW_GA_ACTION = 'UnfollowCollection';

/* GDPR MODAL */
export const GDPR_TITLE_TEXT = lazyGettext('Get updates on this collection');
export const GDPR_MESSAGE_TEXT = lazyGettext(
    'By clicking okay, you are agreeing to receive marketing emails and notifications about collections you follow so that you don’t miss out.',
);
export const GDPR_ACCEPT_TEXT = lazyGettext('Okay');
export const GDPR_REJECT_TEXT = lazyGettext('No Thanks');

/* GDPR */
export const NOTIFICATION_COOKIE = 'ebFollowCollectionNotification';
const NOTIFICATION_COOKIE_EXPIRATION_MONTHS = 3;
export const NOTIFICATION_COOKIE_EXPIRATION_SECONDS =
    60 * 60 * 24 * 30 * NOTIFICATION_COOKIE_EXPIRATION_MONTHS;

export const FALLBACK_IMAGE =
    'https://cdn.evbstatic.com/s3-build/perm_001/979179/django/images/user_profile/empty_collection.png';
